//https://react.dev/learn/extracting-state-logic-into-a-reducer

export default function CoordinatesAutocompleteReducer(locations, action) {

    const handleChangeLocation = () => {
        const newConf = { ...action.payload.conf };
        //imposto la nuova location selezionata
        newConf.selectedPaginationOptions[action.payload.optId].value = action.payload.changedValue;
        //action.payload.setConf(newConf)
        return newConf;
    }

    const handleAddLocation = () => {
        const newConf = { ...action.payload.conf };
        //aggiungo la nuova location
        newConf.selectedPaginationOptions[action.payload.optId].list = [...newConf.selectedPaginationOptions[action.payload.optId].list, action.payload.newValue];
        //selezione automatica della location appena aggiunta
        newConf.selectedPaginationOptions[action.payload.optId].value = action.payload.newValue;
        const updatedConf = { ...newConf };
        /* action.payload.updateConf(updatedConf) */
        /* action.payload.setConf(newConf) */
        return updatedConf
    }

    const handleDeleteLocation = () => {
        const newConf = { ...action.payload.conf };
        //rimozione della location
        newConf.selectedPaginationOptions[action.payload.optId].list = newConf.selectedPaginationOptions[action.payload.optId].list.filter(l => l != action.payload.deletedValue);
        //controllo se la location eliminata era selezionata
        if (newConf.selectedPaginationOptions[action.payload.optId].value == action.payload.deletedValue) {
            //se la location selezionata è stata eliminata imposto di default la prima location nella lista se esite
            newConf.selectedPaginationOptions[action.payload.optId].value = newConf.selectedPaginationOptions[action.payload.optId].list[0] ? newConf.selectedPaginationOptions[action.payload.optId].list[0] : "";
        }
        const updatedConf = { ...newConf };
        /* action.payload.updateConf(updatedConf) */
        /* action.payload.setConf(newConf) */
        return updatedConf
    }

    switch (action.type) {
        case 'changed': {
            const conf = handleChangeLocation();
            return { list: locations.list, conf: conf }; //ritorno le locations senza modifiche (return necessario per ogni case alrimento viene eseguito anche il case di default)
        }
        case 'add': {
            const conf = handleAddLocation();
            return {
                list: [
                    ...locations.list,
                    action.payload.newValue
                ], 
                conf: conf
            };
        }
        case 'delete': {
            const conf = handleDeleteLocation();
            return {list: locations.list.filter(l => l != action.payload.deletedValue), conf:conf};
        }
        default: {
            throw Error('Unknown CoordinatesAutocompleteReducer Action: ' + action.type);
        }
    }
}